module.exports = __webpack_public_path__ + "static/recent-4-c8c6802d788966be833f921ecbe3dbd8.jpg";